import styled from "styled-components/macro";

export default styled.a`
  padding: 15px;
  padding-left: 25px;
  color: inherit;
  text-decoration: inherit;
  display: inherit;

  :hover {
    background-color: ${(props) => props.theme.colors.pastelLilac};
    color: ${(props) => props.theme.colors.primary};
  }
`;
